import { Component, input, Type } from '@angular/core';
import { BaseIconComponent } from '@mars/ui-components';
import { NgComponentOutlet } from '@angular/common';

@Component({
  selector: 'mars-landing-card',
  standalone: true,
  imports: [NgComponentOutlet],
  templateUrl: './landing-card.component.html',
  styleUrl: './landing-card.component.scss',
})
export class LandingCardComponent {
  iconComponent = input<Type<BaseIconComponent>>();
  title = input<string>();
  description = input<string>();
  points = input<string[]>();
  cardClass = input<string>();
}
